(() => {
  'use strict';
  if (document.documentElement.dataset.gosEnabled !== 'true') return;
  const targets = [...document.querySelectorAll('[data-gos-price-handle]')];
  if (!targets.length) return;
  const root = document.documentElement.dataset.cartUrl.replace(/cart\/?$/, '');
  const make = (tag, className, text) => {
    const el = document.createElement(tag);
    el.className = className;
    el.textContent = text;
    return el;
  };
  const render = (target, item) => {
    const current = make('span', 'price__current', '');
    current.append(make('span', 'visually-hidden js-label', item.compareAtPrice ? 'Prix soldé' : 'Prix'));
    current.append(make('span', 'js-value', `${item.priceVaries ? 'À partir de ' : ''}${item.formattedPrice}`));
    const row = make('div', 'price__default', '');
    row.append(current);
    if (item.compareAtPrice) row.append(make('s', 'price__was', item.formattedCompareAtPrice));
    target.replaceChildren(row);
    target.dataset.gosPriceReady = 'true';
    const card = target.closest('product-card');
    if (!card) return;
    if (!item.available) {
      const label = make('span', 'product-label product-label--sold-out', 'Indisponible');
      label.dataset.gosLiveBadge = 'true';
      card.querySelector('.card__media')?.append(label);
    }
  };
  (async () => {
    let page = 1;
    const seen = new Set();
    while (page && !seen.has(page)) {
      seen.add(page);
      const url = new URL(`${root}collections/all-products`, window.location.origin);
      url.searchParams.set('view', 'gos-prices');
      url.searchParams.set('page', String(page));
      // Shopify must render the Liquid view; application/json selects its collection metadata API.
      const response = await fetch(url, { credentials: 'same-origin', headers: { accept: 'text/html' } });
      if (!response.ok) throw new Error('Catalogue prices unavailable');
      const data = await response.json();
      if (!Array.isArray(data.products)) throw new Error('Invalid catalogue price response');
      const products = new Map(data.products.map(item => [item.handle, item]));
      for (const target of targets) {
        const item = products.get(target.dataset.gosPriceHandle);
        if (item) render(target, item);
      }
      page = Number.isInteger(data.nextPage) && data.nextPage > page ? data.nextPage : null;
    }
  })().catch(() => {
    // Each unresolved price remains a working link to its native product page.
    console.warn('Les prix du catalogue seront disponibles sur les fiches produit.');
  });
})();
